import { render, staticRenderFns } from "./CollectionEventDetailsDialog.vue?vue&type=template&id=213e8fa2&"
import script from "./CollectionEventDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectionEventDetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionEventDetailsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
